import './meteostation.css';
import {StateProvider, StateDeclaration} from 'angular-ui-router';
import {AuthGuard} from '../auth/auth-guard';
import StationController from '../station/station.controller';

const template = require<string>('./meteostation.html');

export const configStates = ($stateProvider:StateProvider) => {
  const stateData:any = {};
  stateData[AuthGuard.REQUIRES_AUTH_KEY] = true;
  $stateProvider.state('meteostation', {
    url: '/meteostation?offset&order',
    component: 'imomoMeteostation',
    abstract: true,
    data: stateData,
    params: {
      offset: {dynamic: true},
      order: {dynamic: true}
    }
  });
  $stateProvider.state('meteostation.manager', {
    name: 'meteostation.manager',
    parent: 'meteostation',
    url: '',
    component: 'imomoMeteostationManager'
  });
  $stateProvider.state('meteostation.creator', {
    parent: 'meteostation',
    url: '/new',
    component: 'imomoMeteostationCreator'
  });
  $stateProvider.state('meteostation.historicNorm', {
    parent: 'meteostation',
    url: '/norm/:stationId',
    component: 'imomoMeteostationHistoricNorm'
  });
  $stateProvider.state('meteostation.details', {
    parent: 'meteostation',
    url: '/edit/:stationId',
    component: 'imomoMeteostationDetails'
  });
  $stateProvider.state('meteostation.timeseries', {
    parent: 'meteostation',
    url: '/timeseries/:stationId',
    component: 'imomoMeteostationTimeseries'
  });
};
configStates.$inject = ['$stateProvider'];


export default {
  controller: StationController,
  template
}



/** WEBPACK FOOTER **
 ** ./app/meteostation/meteostation.component.ts
 **/